var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "EditTrade" },
    [
      _vm.isShowNavigate
        ? _c("div", { staticClass: "button-holder top-btn-holder" }, [
            _c("div", { staticClass: "btn-item back-item" }, [
              _c(
                "button",
                {
                  staticClass: "back",
                  on: {
                    click: function ($event) {
                      _vm.isEditTrade = false
                      _vm.isNewTrade = false
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "long-arrow light-arrow",
                    attrs: { src: "/img/long-arrow.png", alt: "" },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "long-arrow dark-arrow",
                    attrs: { src: "/img/long-arrow-dark.png", alt: "" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Special Trades")]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-item" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      return _vm.generateDoc()
                    },
                  },
                },
                [_vm._v("Generate doc")]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isGenerateDoc
        ? _c("generate-doc")
        : _c("div", [
            _c(
              "form",
              { staticClass: "gen-form", attrs: { "data-form": "profile" } },
              [
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [_vm._v("ID")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentProgram.id)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [_vm._v("Active")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.currentProgram.active === "1" ? "true" : "false"
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [_vm._v("Type")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.currentProgram.type_name
                            ? _vm.currentProgram.type_name
                            : _vm.currentProgram.name
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("Commited $")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentProgram.committed,
                        expression: "currentProgram.committed",
                      },
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.currentProgram.committed },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.currentProgram,
                          "committed",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [_vm._v("Start date")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentProgram.start_date)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("End date")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentProgram.end_date,
                        expression: "currentProgram.end_date",
                      },
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.currentProgram.end_date },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.currentProgram,
                          "end_date",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [_vm._v("Asset")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentProgram.asset)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [_vm._v("Operation")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentProgram.operation)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [
                    _vm._v("Current price $"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentProgram.current_price)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("Special price $")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentProgram.special_price,
                        expression: "currentProgram.special_price",
                      },
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.currentProgram.special_price },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.currentProgram,
                          "special_price",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [_vm._v("Created at")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentProgram.created_at)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("span", { staticClass: "key" }, [_vm._v("Created by")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentProgram.user_name)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "updateBtn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.update.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Update")]
                  ),
                  _vm._v(" "),
                  _vm.success
                    ? _c("span", { staticClass: "success" }, [
                        _vm._v(_vm._s(_vm.success)),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "total-block" }, [
                  _vm.error
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.error)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "total-key" }, [
                    _vm._v("Total deposited"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "total-value" }, [
                    _vm._v("$" + _vm._s(_vm.currentProgram.total_deposited)),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.deposits.length
              ? _c("table", { staticClass: "table-basic trade-total" }, [
                  _c(
                    "tbody",
                    _vm._l(_vm.deposits, function (item) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(item.dd, "DD/MM/YYYY HH:MM:SS")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.clearedby))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.reply))]),
                        _vm._v(" "),
                        _c("td", [_vm._v("$ " + _vm._s(item.amount))]),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }